module.exports = __webpack_public_path__ + "static/media/sort-size-up.34aec9c2.svg";